export default "__VITE_ASSET__BF9efgkn__"